import { render } from "./NotifyComponent.vue?vue&type=template&id=48ed10a7&scoped=true"
import script from "./NotifyComponent.vue?vue&type=script&lang=js"
export * from "./NotifyComponent.vue?vue&type=script&lang=js"

import "./NotifyComponent.vue?vue&type=style&index=0&id=48ed10a7&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ed10a7"]])

export default __exports__